import { AbstractControl } from '@angular/forms';
import { FormlyExtension, FormlyFieldConfig } from '@ngx-formly/core';

export class ResetOnChangeExtension implements FormlyExtension {
  onPopulate(field: FormlyFieldConfig): void {
    const props = field.props;
    const keysToReset: string[] | undefined = props?.['resetOnChange'];
    if (!props || !keysToReset?.length || props['_resetOnChangeAttached']) {
      return;
    }
    props['_resetOnChangeAttached'] = true;

    const existingChange = props.change;
    props.change = (f, event) => {
      existingChange?.(f, event);
      keysToReset.forEach((key) => clear(f.form?.root.get(key)));
    };
  }
}

// Not `reset()`: Formly controls treat their initial value as default, so it would restore it.
function clear(control: AbstractControl | null | undefined): void {
  if (control?.value == null) {
    return;
  }
  control.setValue(null);
  control.markAsTouched();
}
